// Immutable state
module.exports = state => state
